import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
    children: ReactNode;
}

interface State {
    hasError: boolean;
    error: Error | null;
    errorInfo: ErrorInfo | null;
}

export class ErrorBoundary extends Component<Props, State> {
    public state: State = {
        hasError: false,
        error: null,
        errorInfo: null
    };

    public static getDerivedStateFromError(error: Error): State {
        return { hasError: true, error, errorInfo: null };
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error('Uncaught error:', error, errorInfo);
        this.setState({ error, errorInfo });
    }

    public render() {
        if (this.state.hasError) {
            return (
                <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-black text-white p-6 text-center">
                    <h1 className="text-2xl font-bold text-red-500 mb-4">Application Error</h1>
                    <p className="mb-4">Sorry, something went wrong.</p>
                    <div className="bg-gray-900 p-4 rounded-lg overflow-auto max-w-full text-left text-xs font-mono text-gray-300 border border-gray-700">
                        <p className="font-bold text-red-400">{this.state.error?.toString()}</p>
                        <pre className="mt-2 text-gray-500">{this.state.errorInfo?.componentStack}</pre>
                    </div>
                    <button
                        onClick={() => window.location.reload()}
                        className="mt-8 px-6 py-3 bg-[#007AFF] rounded-xl font-bold active:scale-95 transition-transform"
                    >
                        Reload App
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}
